import { Injectable } from '@angular/core';
import { Device, DeviceInfo } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private cashedInfo!: DeviceInfo;
  private cashedId: string | null = null;

  get uuid(): string | null {
    return this.cashedId;
  }

  get platform(): string {
    return this.cashedInfo?.platform;
  }

  async init(): Promise<void> {
    try {
      const [info, id] = await Promise.all([Device.getInfo(), Device.getId()]);

      this.cashedInfo = info;
      this.cashedId = info.platform === 'ios' || info.platform === 'android' ? id.identifier : null;
    } catch (error) {
      // eslint-disable-next-line
      console.log('Failed to initialize device data', error);
    }
  }
}
